import { render, staticRenderFns } from "./WebSearch2.vue?vue&type=template&id=91d0c8c8"
import script from "./WebSearch2.vue?vue&type=script&lang=ts"
export * from "./WebSearch2.vue?vue&type=script&lang=ts"
import style0 from "./WebSearch2.vue?vue&type=style&index=0&id=91d0c8c8&prod&lang=css"
import style1 from "../../scss/base.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports